/**
* 系统管理 用户管理
*/
<template>
  <div class="user">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户名称">
        <el-input size="small" v-model="formInline.user_name" placeholder="输入用户名称"></el-input>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input size="small" v-model="formInline.user_id" placeholder="输入用户ID"></el-input>
      </el-form-item>
      <el-form-item label="角色名称">
        <el-input size="small" v-model="formInline.role_name" placeholder="输入角色名称"></el-input>
      </el-form-item>
      <el-form-item label="角色ID">
        <el-input size="small" v-model="formInline.role_id" placeholder="输入角色ID"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search" v-auth="'userauth.list'">搜索
        </el-button>
        <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="handleEdit()"
          v-auth="'userauth.addorupdate'">添加用户</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="el-table-con">
      <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading"
        border element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
        <el-table-column align="center" type="selection" width="50">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="user_id" label="用户ID">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="user_name" label="用户名称">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="role_name" label="角色名称">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="update_time" label="修改时间">
        </el-table-column>
        <el-table-column align="center" sortable="custom" prop="add_time" label="添加时间">
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)" v-auth="'userauth.addorupdate'">编辑</el-button>
            <el-button size="mini" type="success" @click="handlereset(scope.$index, scope.row)"
              v-auth="'userauth.updatepassword'">修改密码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="用户ID" prop="user_id" v-if="editForm.user_id">
          <el-input size="small" v-model="editForm.user_id" auto-complete="off" disabled placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="user_name">
          <el-input size="small" v-model="editForm.user_name" auto-complete="off" placeholder="请输入用户名称"></el-input>
        </el-form-item>
        <el-form-item label="启用" prop="enable">
          <el-radio v-model="editForm.enable" :label="1">是</el-radio>
          <el-radio v-model="editForm.enable" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="角色名称" prop="role_id">
          <el-select size="small" v-model="editForm.role_id" multiple placeholder="请选择" class="userRole">
            <el-option v-for="roleItem in roleList" :key="roleItem.role_id" :label="roleItem.role_name"
              :value="roleItem.role_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="region">
          <el-select size="small" v-model="editForm.region" placeholder="请选择" class="userRole">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="华北" :value="1"></el-option>
            <el-option label="华东" :value="2"></el-option>
            <el-option label="华南" :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="resetFormVisible" width="30%" @click='closeDialog("reset")'>
      <el-form label-width="80px" ref="resetpwd" :model="resetpwd" :rules="resetpwdRules">
        <el-form-item label="新密码" prop="password">
          <el-input size="small" v-model="resetpwd.password" maxlength="16" show-password auto-complete="off"
            placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input size="small" v-model="resetpwd.repassword" maxlength="16" show-password auto-complete="off"
            placeholder="请确认密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("reset")'>取消</el-button>
        <el-button size="small" type="primary" class="title" @click="chooseResetpwd('resetpwd')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // 导入请求方法
  import {
    userList,
    userInfo,
    userSave,
    userPwd,
    roleList,
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    inject: ['reload'],
    data() {
      return {
        loading: false, //是显示加载
        title: '添加用户',
        editFormVisible: false, //控制编辑页面显示与隐藏
        resetFormVisible: false, //控制修改密码显示与隐藏
        // 编辑与添加
        editForm: {
          user_id:'',
          user_name: '',
          enable: 1,
          role_id: [],
          region: 0
        },
        // 选择数据
        selectdata: [],
        // rules表单验证
        rules: {
          user_name: [
            { required: true, message: '请输入用户名称', trigger: 'blur' }
          ],
          role_id: [
            { required: true, message: '请选择角色', trigger: 'blur' }
          ],
        },
        // 重置密码表单验证
        resetpwdRules: {
          password: [
            { required: true, message: '请输入新密码', trigger: 'blur' }
          ],
          repassword: [
            { required: true, message: '请确认密码', trigger: 'blur' }
          ],
        },
        // 重置密码
        resetpwd: {
          user_id: '',
          password: '',
          repassword: ''
        },
        // 请求数据参数
        formInline: {
          pageindex: 1,
          pagesize: 20,
          user_id: '',
          user_name: '',
          role_id: '',
          role_name: '',
          orderby: ''
        },
        //用户数据
        userData: [],
        // 角色数据
        roleList: [],
        // 选中
        checkmenu: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    /**
     * 数据发生改变
     */
    watch: {},

    /**
     * 创建完毕
     */
    created() { },
    mounted() {
      var formInline = localStorage.getItem('userform')
      if (formInline) {
        this.formInline = JSON.parse(formInline)
      }
      this.getdata(this.formInline)
      this.getroleList();
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取数据方法
      getdata(parameter) {
        var that = this;
        that.loading = true
        // 获取用户列表
        userList(parameter).then(res => {
          that.loading = false
          if (res.statusCode == 200 && res.data.datas) {
            that.userData = res.data.datas
            // 分页赋值
            that.pageparm.currentPage = res.data.pageindex
            that.pageparm.pageSize = res.data.pagesize
            that.pageparm.total = res.data.rowscount
          } else {
            that.$message.error(res.message)
          }
        })
      },
      // 获取角色
      getroleList() {
        var that = this;
        roleList().then(res => {
          if (res.statusCode == 200 && res.data.datas) {
            that.roleList = res.data.datas
          } else {
            that.$message.error(res.message)
          }
        })
      },
      // 获取用户信息
      getuserInfo(id) {
        var that = this;
        userInfo({ user_id: id }).then(res => {
          if (res.statusCode == 200) {
            var arrIntSet = []
            if (null != res.data.role_id && "" != res.data.role_id && res.data.role_id != 'string') {
              // 将字符串转换成数组，此时是字符串数组
              var arrString = res.data.role_id.split(',')
              // 将字符串数组的每一项转换成Number，生成一个新的数组
              for (var arrInt in arrString) {
                arrIntSet.push(parseInt(arrString[arrInt]))
              }
            }
            res.data.role_id = arrIntSet
            that.editForm = res.data;
          } else {
            that.$message.error(res.message)
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.pageindex = parm.currentPage
        this.formInline.pagesize = parm.pageSize
        localStorage.setItem('userform', JSON.stringify(this.formInline))
        this.getdata(this.formInline)
      },
      // 排序
      sortChange(column, prop, order) {
        var order = '';
        if (column.order == 'ascending') {
          order = 'asc'
        } else if (column.order == 'descending') {
          order = 'desc'
        }
        if (order) {
          this.formInline.orderby = column.prop + ' ' + order
          this.search();
        }
      },
      //搜索事件
      search() {
        this.formInline.pageindex = 1;
        localStorage.setItem('userform', JSON.stringify(this.formInline))
        this.getdata(this.formInline)
      },
      // 重置
      reset() {
        this.formInline = {
          pageindex: 1,
          pagesize: 20,
          user_id: '',
          user_name: '',
          role_id: '',
          role_name: '',
          orderby: ''
        }
        // 重置清掉本地搜索缓存
        localStorage.removeItem('userform')
        this.getdata(this.formInline)
      },
      //显示编辑界面
      handleEdit: function (row) {
        var that = this;
        if (row != undefined && row != 'undefined') {
          that.title = '修改用户'
          that.getuserInfo(row.user_id);
        } else {
          that.title = '添加用户'
          that.editForm = {
            user_id:'',
            user_name: '',
            enable: 1,
            role_id: [],
            region: 0
          }
        }
        that.editFormVisible = true
      },
      // 编辑、添加提交方法
      submitForm(editData) {
        var that = this;
        this.$refs[editData].validate(valid => {
          if (valid) {
            var editForm = that.editForm
            editForm.role_id = editForm.role_id.join(',');
            // 添加没有user_id
            if (!editForm.user_id) {
              delete editForm.user_id
            }
            // 请求方法
            userSave(that.editForm)
              .then(res => {
                that.editFormVisible = false
                if (res.statusCode == 200) {
                  // 添加用户时清空搜索条件
                  if (that.title == '添加用户') {
                    that.reset();
                  } else {
                    that.getdata(that.formInline)
                  }
                  that.$message({
                    type: 'success',
                    message: that.title + '成功！'
                  })
                } else {
                  that.$message.error(res.message)
                }
              })
          } else {
            return false
          }
        })
      },
      // 选择复选框事件
      selectChange(val) {
        this.selectdata = val
      },
      // 关闭编辑、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        } else if (dialog == 'reset') {
          this.resetFormVisible = false
        }
      },
      // 显示修改密码界面
      handlereset(index, row) {
        var that = this;
        that.resetpwd.user_id = row.user_id;
        that.resetFormVisible = true;
      },
      // 修改密码
      chooseResetpwd(resetpwd) {
        var that = this;
        this.$refs[resetpwd].validate(valid => {
          if (valid) {
            // 判断两次密码是否一致
            if (that.resetpwd.password !== that.resetpwd.repassword) {
              that.$message.error('密码错误！')
              return;
            }
            // 请求方法
            userPwd(that.resetpwd)
              .then(res => {
                that.resetFormVisible = false
                if (res.statusCode == 200) {
                  that.$message({
                    type: 'success',
                    message: '修改密码成功！'
                  })
                  that.getdata(this.formInline)
                } else {
                  that.$message.error(res.message)
                }
              })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>
<style>
  .user .el-table-con {
    height: calc(100vh - 380px) !important;
  }

  .user .page-box {
    text-align: right !important;
  }

  /* 固定el-table头部 */
  .user .el-table {
    max-height: calc(100vh - 380px) !important;
  }

  .user .el-table__body-wrapper.is-scrolling-none {
    overflow-y: auto !important;
    max-height: calc(100vh - 465px) !important;
  }

  .user .el-dialog__body {
    max-height: 55vh;
    overflow-y: scroll;
  }

  .user .el-dialog__body::-webkit-scrollbar {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/views/system/user.vue